('use strict');
class DemandesApprenantsListComponent {
  constructor(
    $sce,
    $httpParamSerializer,
    $state,
    $stateParams,
    configuration,
    jwtSessionService,
    IFrameCommunicationManager,
    routeUtilsService
  ) {
    this.$sce = $sce;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$httpParamSerializer = $httpParamSerializer;
    this.configuration = configuration;
    this.jwtSessionService = jwtSessionService;
    this.iFrameCommunicationManager = new IFrameCommunicationManager('#demandesApprenantsIframe');
    this.routeUtilsService = routeUtilsService;
  }

  $onInit() {
    this.activeTab = this.$stateParams.activeTab || 'opened';
    this.page = this.$stateParams.page || 1;
    this.activeFilters = this.$stateParams.activeFilters;

    const demandesApprenantsIframeQueryParams = this.$httpParamSerializer({
      jwtKey: this.jwtSessionService.getJwtKey(),
      tiersKey: 'current-tiers-ref',
      activeTab: this.activeTab,
      page: this.page,
      activeFilters: this.activeFilters,
    });

    const templateDemandesApprenantsIframeSrc = `${this.configuration.ux}<%= tenantId %>/demandes-apprenants-view?<%= queryParams %>`;
    const compiledDemandesApprenantsIframeSrc = _.template(templateDemandesApprenantsIframeSrc);
    const demandesApprenantsListIframeSrc = compiledDemandesApprenantsIframeSrc({
      tenantId: this.configuration.tenant.id,
      queryParams: demandesApprenantsIframeQueryParams,
    });

    this.demandesApprenantsListIframeSrc = this.$sce.trustAsResourceUrl(demandesApprenantsListIframeSrc);

    this.onIframeEvent = ({ data = {} }) => {
      const { route, action, value } = data;
      if (route === 'demandes-apprenants-view.ux') {
        switch (action) {
          case 'update-tab':
            this.activeTab = value.tab;
            this.page = value.page?.toString() ?? '1';
            this.activeFilters = value.activeFilters;
            this.$state.go('.', { activeTab: this.activeTab, page: this.page, activeFilters: this.activeFilters });
            break;
          case 'update-page': // update page in url
            this.page = value?.toString();
            this.$state.go('.', { activeTab: this.activeTab, page: this.page, activeFilters: this.activeFilters });
            break;
          case 'update-active-filters':
            this.activeFilters = value;
            this.$state.go('.', { activeTab: this.activeTab, page: this.page, activeFilters: this.activeFilters });
            break;
          case 'contribution-information':
            this.routeUtilsService.goToContributionInformationEdit(
              value.configurationId,
              value.demandeReference,
              value.contributionInformationReference
            );
            break;
          default: // when demande apprenant action is clicked
            this.routeUtilsService.goToDemandesApprenants(action, value, {
              fromTab: this.activeTab,
              fromPage: this.page,
              activeFilters: this.activeFilters,
            });
        }
      }
    };
    this.iFrameCommunicationManager.manageEvent(this.onIframeEvent);
  }

  $onDestroy() {
    this.iFrameCommunicationManager.close();
  }
}

DemandesApprenantsListComponent.$inject = [
  '$sce',
  '$httpParamSerializer',
  '$state',
  '$stateParams',
  'configuration',
  'jwtSessionService',
  'IFrameCommunicationManager',
  'routeUtilsService',
];

angular.module('demandes-apprenants.components').component('demandesApprenantsListComponent', {
  templateUrl: 'dashboard/demandes-apprenants/list/demandes-apprenants-list.html',
  controller: DemandesApprenantsListComponent,
});
